import React from "react";
import { string, bool, shape, number } from "prop-types";

import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";

import { resizableRoute as resizableComponent } from "pages/_components/Resizable";
import { isIOS } from "react-device-detect";
import CustomDetailAccount from "../CustomDetailAccount/CustomDetailAccount";

const CustomHeadInfo = resizableComponent((props) => {
    const {
        balance,
        countableBalance,
        currency,
        overdraftLine,
        account,
        isDesktop,
        handleClickShowQr,
        pendingBalance,
    } = props;
    return (
        <>
            <CustomDetailAccount account={account} openQr={handleClickShowQr} {...props} />
            <GridTable className={isIOS ? "balance-info mt-5" : "balance-info"}>
                <GridTable.Container>
                    <GridTable.Data alignX="left" rowStart={1}>
                        <CustomData
                            titleText="accounts.openingBalance"
                            titleClass="primary"
                            dataClass="primary"
                            titleTextType="I18N"
                            valueText={balance}
                            valueTextType={currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data alignX="left" rowStart={isDesktop ? 1 : 2}>
                        <CustomData
                            titleText="accounts.agreements"
                            titleClass="primary"
                            dataClass="primary"
                            titleTextType="I18N"
                            valueText={overdraftLine}
                            valueTextType={currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data alignX="left" rowStart={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="accounts.creditBalance"
                            titleClass="primary"
                            dataClass="primary"
                            titleTextType="I18N"
                            valueText={pendingBalance}
                            valueTextType={currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data alignX="left" rowStart={isDesktop ? 1 : 4}>
                        <CustomData
                            titleText="accounts.availableAccountBalance"
                            titleClass="primary"
                            titleTextType="I18N"
                            valueText={countableBalance}
                            valueTextType={currency}
                            dataClass="balance transfer-data-highlight primary"
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
});

CustomHeadInfo.propTypes = {
    account: shape({
        idEnvironment: number,
        idProduct: string,
        productType: string.isRequired,
        productAlias: string,
        label: string,
        shortLabel: string,
        extraInfo: string,
        number: string.isRequired,
        ownerName: string,
        currency: string.isRequired,
        extraInfoMarked: string,
        isOperative: bool,
    }),
    balance: number,
    countableBalance: number,
    currency: string,
    overdraftLine: number,
    pendingBalance: number,
};

CustomHeadInfo.defaultProps = {
    account: { productAlias: "", extraInfoMasked: "", blocked: "" },
    balance: 0,
    countableBalance: 0,
    currency: "",
    overdraftLine: 0,
    pendingBalance: 0,
};

export default CustomHeadInfo;
